const tooltipCommentFlagIcon = {
  tooltip: 'Question has comment option',
  tooltipFileFlag: 'Question has file option',
};

export default tooltipCommentFlagIcon;
